/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UssdStatus } from './ussdStatus';

export interface UssdHubBillingLogDto { 
    sessionId?: string;
    subscriberPhoneNumber?: string;
    shortCode?: string;
    serviceProviderId?: string;
    ussdString?: string;
    ussdResult?: string;
    userInput?: string;
    keyNumber?: string;
    dateCreated?: Date;
    dateTimeStarted?: Date;
    dateTimeEnded?: Date;
    ussdStatus?: UssdStatus;
    hops?: number;
    duration?: number;
}